const gridCols: { [key: number]: string } = {
  6: 'grid-cols-6',
  7: 'grid-cols-7',
};

export function getDetailsGridClass(selectedDaysLength: number): string {
  return gridCols[selectedDaysLength as keyof typeof gridCols] ?? 'grid-cols-5';
}
